const DIACRITICS = /[̀-ͯ]/g;
const NON_SLUG_CHARACTERS = /[^a-z0-9\s-]/g;
const SEPARATORS = /[\s-]+/g;

export const slugify = (value: string): string =>
	value.normalize("NFD").replace(DIACRITICS, "").toLowerCase().replace(NON_SLUG_CHARACTERS, "").trim().replace(SEPARATORS, "-");
